// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"6444bbd9","264":"37c7f15c","654":"7fb9f07c","787":"c5cd146d","961":"8d054f98"}[chunkId] + ".chunk.js";
};